var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getTitle)?_c('label',{class:_vm.getLabelClass},[_vm._v(_vm._s(_vm.getTitle))]):_vm._e(),_c('tiptap-vuetify',{staticClass:"tiptapeditor",attrs:{"extensions":_vm.getExtensions,"toolbar-attributes":{
            dark: true,
            color: 'grey'
         }},on:{"input":_vm.handleInput},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }